/**
 * Canonical domain for all shared / copied links.
 * Always use this instead of window.location.origin so links
 * open correctly in mobile browsers (Android/iOS) rather than
 * triggering preview URLs or "no app found" errors.
 */
export const CANONICAL_ORIGIN = 'https://hairproencyclopedia.ai';

export function canonicalUrl(path: string): string {
  const cleanPath = path.startsWith('/') ? path : `/${path}`;
  return `${CANONICAL_ORIGIN}${cleanPath}`;
}
